import BaseApiRequestService from './BaseApiRequestService';

class AdminApiRequestService extends BaseApiRequestService {
  protected readonly serviceURL = 'https://2d62ywan1l.execute-api.sa-east-1.amazonaws.com/prod/admin';
}

export default new AdminApiRequestService();
